import { render, staticRenderFns } from "./NetaListEventComponent.vue?vue&type=template&id=508ee378&scoped=true&"
import script from "./NetaListEventComponent.vue?vue&type=script&lang=js&"
export * from "./NetaListEventComponent.vue?vue&type=script&lang=js&"
import style0 from "./NetaListEventComponent.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./NetaListEventComponent.vue?vue&type=style&index=1&id=508ee378&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508ee378",
  null
  
)

export default component.exports